import { render } from "./CategoriaRapidaModal.vue?vue&type=template&id=83a319c8"
import script from "./CategoriaRapidaModal.vue?vue&type=script&lang=js"
export * from "./CategoriaRapidaModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__